import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthGuard} from '../../../common/auth-guard.service';
import {AlarmsService} from '../../../services/alarms.service';
import {SortOrder} from '../../../model/sort-order';
import {ColorService} from 'src/app/services/color.service';
import {AlarmDefinitionFilters} from 'src/app/model/filters/alarm-definition-filters';
import {AlarmDefinition} from 'src/app/model/alarm-definition';
import {CommonMessagesService} from 'src/app/services/common-messages.service';
import {TranslocoService} from '@ngneat/transloco';
import {Operation} from 'src/app/model/operation';
import {MachinesService} from 'src/app/services/machines.service';
import {AccountService} from "../../../services/account.service";
import {Organization} from "../../../model/organization";
import {CommonTranslationsService} from "../../../services/common-translations.service";

@Component({
  selector: 'app-alarm-definition',
  templateUrl: './alarm-definition.component.html',
  styleUrls: ['./alarm-definition.component.scss']
})
export class AlarmDefinitionComponent implements OnInit {

  public alarms: AlarmDefinition[];
  public totalAlarms: number;
  public loadingAlarms: boolean;
  public userOrganization: Organization;

  public rows: number = 10;
  public first: number = 0;

  public filtersVisible: boolean;
  public currentFilters: AlarmDefinitionFilters;

  public operationOptions: { label: string, value: Operation }[] = [];
  public deviceMeasurements: { label: string, value: string }[] = [];

  public operationsTranslation: { [key: string]: string } = {};

  private expandedRows: any = {};


  constructor(private route: ActivatedRoute,
              private readonly alarmsService: AlarmsService,
              private readonly colorService: ColorService,
              private readonly commonMessageService: CommonMessagesService,
              private readonly router: Router,
              private readonly i18n: TranslocoService,
              private readonly machinesService: MachinesService,
              private readonly accountService: AccountService,
              private readonly commonTranslationsService: CommonTranslationsService,
              public authGuardService: AuthGuard
  ) {
    this.currentFilters = new AlarmDefinitionFilters();
  }

  ngOnInit(): void {
    this.accountService.getOrganizationOfLoggedUser().subscribe(response => {
      this.userOrganization = response.organization
    });
    this.alarms = new Array(this.rows);
    this.loadFilters();
  }

  private loadAlarms(offset: number, limit: number): void {
    this.loadingAlarms = true;
    this.alarms = new Array(this.rows);
    this.trimFieldsForm(this.currentFilters);
    this.alarmsService.getAlarmsDefinition(offset, limit, this.currentFilters).subscribe((response) => {
      this.i18n.selectTranslation().subscribe(() => {
        this.alarms = response.data.content;
        this.totalAlarms = response.data.totalElements;
        this.loadingAlarms = false;
      });
    });
  }

  trimFieldsForm(filters: AlarmDefinitionFilters): void {
    Object.keys(filters).forEach((key: string) => {
      if (filters[key] != undefined && typeof filters[key] === 'string') {
        filters[key] = filters[key].trim();
      }
    });
  }

  onPageChange(event): void {
    this.expandedRows = {};
    this.currentFilters.sortField = event.sortField;
    this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.route.params.subscribe(() => this.loadAlarms(event.first / event.rows, event.rows));
  }

  loadFilters(): void {
    this.buildAlarmDeviceMeasurementOptions();
    this.buildAlarmOperationOptions();
    this.buildOperationsTranslation();
  }

  private buildAlarmDeviceMeasurementOptions(): void {
    this.machinesService.getAlarmDeviceMeasurements().subscribe(response => {
      this.deviceMeasurements = response.deviceMeasurements
        .map(sensor => ({label: sensor, value: sensor}))
        .sort((a, b) => a.label.localeCompare(b.label));
    });
  }

  private buildAlarmOperationOptions(): void {
    this.commonTranslationsService.getAlarmOperationOptions().subscribe(operationsOptions => {
      this.operationOptions = operationsOptions;
    });
  }

  private buildOperationsTranslation(): void {
    this.commonTranslationsService.getOperationsTranslation().subscribe(operationsTranslation => {
      this.operationsTranslation = operationsTranslation;
    });
  }

  public mapProperty(array: any[], property: string): any[] {
    return array.map(i => i[property]);
  }

  public confirmAndDelete(alarm: AlarmDefinition): void {
    this.commonMessageService.showDeleteRequestConfirmation(() => {
      this.alarmsService.deleteAlarmDefinition(alarm.alarmDefinitionUuid).subscribe({
        next: () => {
          this.commonMessageService.showSuccessfullyDeletedMessage();
          this.loadAlarms(this.first / this.rows, this.rows);
        },
        error: (error) => this.commonMessageService.showErrorWhileDeletingMessage(error)
      })
    })
  }

  resetFilters(): void {
    this.currentFilters = new AlarmDefinitionFilters();
    this.currentFilters.sortField = 'deactivationDate';
    this.currentFilters.sortOrder = 1;
    this.expandedRows = {};
  }

  applyFilters(): void {
    this.first = 0;
    this.loadAlarms(this.first / this.rows, this.rows);
  }

  adjustTextColor(colorHex): string {
    return this.colorService.adjustTextColor(colorHex);
  }

}

